import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.date.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";

import { useRoute } from 'vue-router';
import { computed } from 'vue';
var _hoisted_1 = {
  "class": "Footer mt-2xl border-t border-solid border-zinc-700"
};
var _hoisted_2 = {
  "class": "py-lg"
};
var _hoisted_3 = {
  "class": "container relative flex items-center justify-between"
};
var _hoisted_4 = {
  "class": "Footer__currency"
};
var _hoisted_5 = {
  "class": "Footer__links"
};
var _hoisted_6 = ["href"];
var _hoisted_7 = {
  "class": "Footer__social flex justify-end items-center"
};
var _hoisted_8 = ["href"];
var _hoisted_9 = {
  "class": "text-center text-zinc-500"
};
var _hoisted_10 = {
  "class": "container"
};
var _hoisted_11 = {
  "class": "relative flex items-center justify-between py-lg border-y border-solid border-zinc-700"
};
var _hoisted_12 = {
  "class": "Footer__grid"
};
var _hoisted_13 = {
  "class": "PBDropdown__list"
};
var _hoisted_14 = {
  "class": "PBDropdown__item"
};
var _hoisted_15 = {
  href: "https://bequant.pro",
  target: "_blank"
};
var _hoisted_16 = {
  "class": "PBDropdown__item"
};
var _hoisted_17 = {
  href: "https://bequant.io",
  target: "_blank"
};
var _hoisted_18 = {
  "class": "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
};
var _hoisted_19 = {
  "class": "Footer__terms"
};
var _hoisted_20 = {
  "class": "flex items-center text-sm"
};
var _hoisted_21 = ["href"];
var _hoisted_22 = {
  key: 0,
  "class": "text-zinc-500 px-2xl py-lg text-sm"
};
export default {
  __name: 'Footer',
  props: {
    empty: Boolean
  },
  setup: function setup(__props) {
    var VUE_APP_API_URL = process.env.VUE_APP_API_URL;
    var route = useRoute();
    var links = [{
      url: "https://intercom.help/bequant/en/collections/3030720-bequant-prime-brokerage",
      text: "Support centre"
    }, {
      url: "https://bequant.pro/company/about#contact_us_form",
      text: "Connect"
    }, {
      url: "https://insights.bequant.pro",
      text: "Insights"
    }, {
      url: "".concat(VUE_APP_API_URL, "/uapi-docs/"),
      text: "API"
    }];
    var terms = [{
      url: "https://bequant.pro/prime-terms-of-service",
      text: "Terms of service"
    }];
    var socials = [{
      url: "https://twitter.com/bequant_group",
      width: 18,
      height: 14,
      name: "twitter"
    }, {
      url: "https://www.facebook.com/BEQUANTGROUP/",
      width: 9,
      height: 16,
      name: "facebook"
    }, {
      url: "https://www.linkedin.com/company/bequantgroup/",
      width: 14,
      height: 14,
      name: "linkedin"
    }, {
      url: "https://medium.com/@BEQUANT",
      width: 19,
      height: 15,
      name: "medium"
    }];
    var noDisclaimer = computed(function () {
      return ['outages', 'login', 'register', 'confirm-registration'].includes(route.name);
    });
    return function (_ctx, _cache) {
      var _component_CurrencySelector = _resolveComponent("CurrencySelector");
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBDropdown = _resolveComponent("PBDropdown");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_CurrencySelector, {
        disabled: __props.empty
      }, null, 8, ["disabled"])]), _createElementVNode("ul", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, function (link, index) {
        return _createElementVNode("li", {
          key: index
        }, [_createElementVNode("a", {
          href: link.url,
          target: "_blank"
        }, _toDisplayString(link.text), 9, _hoisted_6)]);
      }), 64))]), _createElementVNode("ul", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, function (item, index) {
        return _createElementVNode("li", {
          key: index,
          "class": "ml-sm"
        }, [_createElementVNode("a", {
          href: item.url,
          "class": _normalizeClass([item.name, "flex justify-center items-center w-[32px] h-[32px] rounded-md border border-solid border-zinc-600 transition-all hover:bg-white hover:border-white"]),
          target: "_blank"
        }, [_createVNode(_component_PBIcon, {
          name: item.name,
          w: item.width,
          h: item.height
        }, null, 8, ["name", "w", "h"])], 10, _hoisted_8)]);
      }), 64))])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_PBDropdown, {
        selectable: false,
        chevron: false,
        top: "",
        left: ""
      }, {
        icon: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_PBIcon, {
            name: "grid",
            w: 18,
            h: 18
          }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "Products", -1))])];
        }),
        menu: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_createElementVNode("a", _hoisted_15, [_createVNode(_component_PBIcon, {
            name: "logo-mini",
            w: 24,
            h: 24
          }), _cache[1] || (_cache[1] = _createElementVNode("span", null, [_createElementVNode("span", null, "BEQUANT Prime Brokerage"), _createElementVNode("span", null, "Monitor & Manage Assets")], -1))])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("a", _hoisted_17, [_createVNode(_component_PBIcon, {
            name: "logo-mini",
            w: 24,
            h: 24
          }), _cache[2] || (_cache[2] = _createElementVNode("span", null, [_createElementVNode("span", null, "BEQUANT Exchange"), _createElementVNode("span", null, "Buy & Sell Cryptocurrency")], -1))])])])])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_18, " © 2018 - " + _toDisplayString(new Date().getFullYear()) + " BEQUANT ", 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("ul", _hoisted_20, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(terms, function (link, index) {
        return _createElementVNode("li", {
          key: index,
          "class": "font-semibold"
        }, [_createElementVNode("a", {
          href: link.url,
          target: "_blank"
        }, _toDisplayString(link.text), 9, _hoisted_21)]);
      }), 64))])])])])]), !_unref(noDisclaimer) ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toConsumableArray(_cache[3] || (_cache[3] = [_createElementVNode("p", {
        "class": "mb-md"
      }, " Please be advised that the financial information presented on this page is provided for informational purposes only. It is not intended for use in official financial or regulatory reporting. Some content on the Bequant website is sourced from independent third parties, such as exchanges, over which Bequant has no control. As such, Bequant cannot verify the accuracy or completeness of such content. While reasonable efforts are made to ensure reliability, Bequant does not guarantee the accuracy, completeness, or suitability of the information for any specific purpose. ", -1), _createElementVNode("p", {
        "class": "mb-md"
      }, " The information on this page may not be up-to-date, comprehensive, or complete and should not be relied upon for making financial decisions or financial reporting. Bequant is not liable for any errors, omissions, or consequences arising from the use of this information. Any reliance on the content is at your own risk. ", -1), _createElementVNode("p", null, [_createTextVNode(" We recommend consulting with professional advisers before making any financial decisions based on the information provided here. By using this page, you agree that Bequant and its affiliates are not liable for any decisions made by You or your affiliates based on the information provided "), _createElementVNode("a", {
        href: "https://bequant.pro/risk-disclosure-statement",
        target: "_blank",
        "class": "text-zinc-500 underline hover:text-zinc-600"
      }, "here"), _createTextVNode(". ")], -1)])))) : _createCommentVNode("", true)]);
    };
  }
};